/**
 * Data print format values.
 */
export enum DataPrintFormatEnum {
	HTML = 'html',
	PDF = 'pdf',
}
